// adapted from https://github.com/cpv123/react-admin-hasura-queries/blob/master/src/custom-build-fields.ts

import {IntrospectionObjectType} from 'graphql'
import gql from 'graphql-tag'
import {buildFields, FetchType} from 'ra-data-hasura'
import {FieldNode} from 'ra-data-hasura/node_modules/graphql/language/ast'

const extractFieldsFromQuery = queryAst => queryAst.definitions[0].selectionSet.selections

const GET_MANY_CHANNELS = gql`{
  id
  merchantId
  name
  whatsappAccount{phoneNumber}
  whatsappAccountId
}`

const GET_ONE_CAMPAIGN = gql`{
  audienceType
  channelId
  chatMessageTemplateId
  id
  insertionUser{
    merchantUser{firstName lastName}
  }
  insertionTimestamp
  insertionUserId
  isDeleted
  isListed
  name
  scheduledTimestamp
  status
}`

// Temporarily omit computed columns which are not required in campaigns list
// to avoid loading computed fields which are expensive to fetch and make the
// entire campaigns list load very slowly.
const GET_MANY_CAMPAIGNS = gql`{
  audienceType
  channelId
  chatMessageTemplateId
  id
  insertionTimestamp
  insertionUserId
  isDeleted
  isListed
  name
  scheduledTimestamp
}`

const GET_MANY_MERCHANT_CUSTOMER_USER_CONTACT_GROUPS = gql`{
  contactGroupId
  contactGroup{name}
  merchantCustomerUserId
}`

const GET_MANY_MERCHANT_CUSTOMERS = gql`{
  birthdayDate
  companyCity
  companyHouseNumber
  companyName
  companyStreet
  companyZipCode
  customerCode
  customerUser{whatsappDisplayName}
  customerUserId
  emailAddress
  firstName
  id
  isMarketingConsentGranted
  lastName
  placeholder
  primaryResponsibleMerchantUserId
  role
  trade
  whatsappPhoneNumber
}`

const GET_MANY_MERCHANT_CUSTOMER_USER_TAGS = gql`{
  merchantCustomerUserId
  tagId
  tag{name}
}`

const GET_ONE_CHAT_MESSAGE_TEMPLATE = gql`{
  chatMessageTemplateButtons{
    copyCodeExample
    id
    quickReply
    phoneNumber
    phoneNumberCountryCode
    phoneNumberText
    type
    url
    urlParameterExample
    urlText
    urlType
  }
  buttonText
  buttonUrl
  footer
  headerMediaKey
  headerMediaMimeType
  headline
  id
  insertionTimestamp
  language
  name
  rejectionReason
  status
  text
  type
}`

const CUSTOM_QUERIES = {
  campaigns: {
    GET_LIST: GET_MANY_CAMPAIGNS,
    GET_ONE: GET_ONE_CAMPAIGN,
    UPDATE: GET_MANY_CAMPAIGNS,
  },
  channels: {
    GET_MANY: GET_MANY_CHANNELS,
  },
  chat_message_templates: {
    GET_ONE: GET_ONE_CHAT_MESSAGE_TEMPLATE,
  },
  merchant_customer_user_contact_groups: {
    GET_LIST: GET_MANY_MERCHANT_CUSTOMER_USER_CONTACT_GROUPS,
  },
  merchant_customer_user_tags: {
    GET_LIST: GET_MANY_MERCHANT_CUSTOMER_USER_TAGS,
  },
  merchant_customer_users: {
    GET_LIST: GET_MANY_MERCHANT_CUSTOMERS,
  },
}

const dataProviderCustomBuildFields = (
  type: IntrospectionObjectType, fetchType?: FetchType
): FieldNode[] => {
  // TODO: Merge custom query fields with all known fields from the schema so that we
  // only need to specify additional relationships in our custom queries. This will
  // prevent from forgetting to add new table columns as the queries are now no longer
  // auto-generated by `ra-data-hasura`. To solve this, we can probably call
  // `buildFields(type, fetchType)` and then merge the result w/ our custom query.
  const customQuery = CUSTOM_QUERIES[type.name]?.[fetchType]
  return customQuery ?
    extractFieldsFromQuery(customQuery) as FieldNode[] :
    buildFields(type as any, fetchType)
}

export default dataProviderCustomBuildFields
